import { Glympse } from './glympse';
import { StoreWorkingHours } from './store';
import { MapCoordinates } from './map';
import { JobPhase } from './jobs';

export interface Organization {
  admin_email: string;
  created_time: Date;
  glympse: Glympse;
  glympse_api_key: string;
  glympse_api_server: string;
  hierarchy: any[];
  last_modifies: Date;
  name: string;
  parent_id: number;
  partner_id: number;
  referrer_org_id: number;
  root_id: number
  tags: any[];
  _id: number;
  config?: OrganizationConfig;
  children?: Organization[];
  base_location: BaseLocation;
  pickup_hours: StoreWorkingHours;
  store_hours: StoreWorkingHours;
  pickup_location?: string;
  pickup_coordinates?: MapCoordinates;
  billing_subscription: BillingSubscription;
}

export interface OrganizationWithChildren extends Organization {
  children?: OrganizationWithChildren[];
}

export interface BaseLocation {
  lat: number;
  lng: number;
  name: string;
}

export interface OrganizationConfig {
  _id: number;
  org_id: number;
  tasks?: {
    image_upload?: {
      signature?: boolean;
      photo?: boolean;
    };
  };
  sessions?: {
    enabled?: boolean;
  };
  phases?: {
    types?: {
      [key in JobPhase]: any
    }
  },
  apps?: {
    pickup?: {
      enabled?: boolean;
    };
    drivers?: {
      behavior?: string;
      enabled?: boolean;
    }
  };
  agent?: {
    multi_chat_access?: boolean;
  };
}

export interface ConfigUpdateItem {
  path: string;
  value: any;
}

export interface BillingSubscription {
  max_agents?: number,
  current_plans?: {
    subscription_id: string,
    status: SubscriptionStatus,
    items: Array<{
      plan: string
      quantity: number,
      next_bill_at: number
    }>
  },
  expiration?: number
}

export enum SubscriptionStatus {
  NonRenewing = 'non_renewing',
  Paused = 'paused',
  Cancelled = 'cancelled',
  InTrial = 'in_trial',
  Active = 'active',
}
